import _ from 'lodash';
import {
	GET_ITEMS_START,
	GET_ITEMS_SUCCESS,
	GET_ITEMS_FAIL,
	DELETE_ITEM_START,
	DELETE_ITEM_SUCCESS,
	DELETE_ITEM_FAIL,
	UPDATE_ITEM_START,
	UPDATE_ITEM_SUCCESS,
	UPDATE_ITEM_FAIL,
} from 'admin/constants';
import { RESET_ITEMS } from 'client/constants';

const initialState = {
	fetching: false,
	data: {},
};

export default function itemsReducer(state = initialState, action) {
	if ([GET_ITEMS_START, DELETE_ITEM_START, UPDATE_ITEM_START].some(a => a === action.type)) {
		const currentState = { ...state };

		if (action.type === GET_ITEMS_START) {
			currentState.data = {};
		}

		return { ...currentState, fetching: true };
	}

	if ([GET_ITEMS_FAIL, DELETE_ITEM_FAIL, UPDATE_ITEM_FAIL].some(a => a === action.type)) {
		return { ...state, fetching: false };
	}

	if (action.type === GET_ITEMS_SUCCESS) {
		return { data: action.payload, fetching: false };
	}

	if (action.type === DELETE_ITEM_SUCCESS) {
		return { data: _.omit(state.data, [action.payload.id]), fetching: false };
	}

	if (action.type === UPDATE_ITEM_SUCCESS) {
		return { data: { ...state.data, [action.payload.id]: action.payload }, fetching: false };
	}

	if (action.type === RESET_ITEMS) {
		return {
			data: {},
			fetching: false,
		};
	}

	return state;
}
